
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 42 42","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.735 17.5a2 2 0 01-1.913-1.419l-1.908-6.28c-.575-1.892-3.253-1.893-3.828 0l-1.908 6.28a2 2 0 01-1.913 1.419h-5.52C7.8 17.5 7 19.998 8.586 21.128l4.554 3.25a2 2 0 01.749 2.22l-1.84 5.944c-.576 1.858 1.571 3.36 3.12 2.183l4.623-3.513a2 2 0 012.419-.001l4.643 3.523c1.55 1.176 3.695-.327 3.12-2.184l-1.843-5.953a2 2 0 01.747-2.219l4.548-3.25c1.583-1.132.783-3.628-1.163-3.628h-5.527z","fill":"#E6E7E9"}})])
          )
        }
      }
    